<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template lang="html">
  <section class="TokPaywall">
    <Redeem v-if="displayRedeem" />
    <navBar title="Paywall"></navBar>
    <carousel
      class="carousel"
      :perPage="1"
      :navigationEnabled="false"
      :paginationEnabled="true"
      :autoplay="true"
      :autoplayTimeout="5000"
      :autoplayHoverPause="true"
      :paginationActiveColor="colors.paginationActiveColor"
      :paginationColor="colors.paginationColor"
    >
      <template v-for="cover in availablePlans.covers">
        <slide
          class="slide"
          :key="cover"
          :style="'padding-top:33%; position: relative; flex-basis: 100%;'"
        >
          <bkg :url="cover"></bkg>
        </slide>
      </template>
    </carousel>
    <div class="PayWall__modal__current" v-if="hasSubscription">
      <div class="PayWall__modal__current__el__title" style="margin-bottom: 20px;">{{$t('ACTIVE_PLANS_HEADER')}}</div>
      <div class="PayWall__modal__current__el" :key="plan.title"
           v-for="plan in availablePlans.active_plans">
        <div class="PayWall__modal__current__el__plan">
          <div class="PayWall__modal__current__el__plan__name">{{ plan.title }}</div>
          <!--<div class="PayWall__modal__current__el__plan__renew"></div>-->
        </div>
        <!--<div class="PayWall__modal__current__el__price"></div>-->
      </div>
    </div>
    <template v-if="hasUpgrades">
      <div class="PayWall__modal__title"
           v-text="hasSubscription ? $t('OTHER_AVAILABLE_PLANS_HEADER') : $t('AVAILABLE_PLANS_HEADER')">
      </div>
      <div class="PayWall__modal__options">
        <form class="PayWall__modal__options__option" v-for="plan in paypal"
              :action="plan.button_url" method="post"
              :key="plan.button_id"
              :ref="plan.button_id"
              target="_top">
          <input type="hidden" name="cmd" value="_s-xclick">
          <input type="hidden" name="hosted_button_id" :value="plan.button_id">
          <input type="hidden" name="return" :value="encodeURI(paymentReturnUrl)">
          <input type="hidden" name="cancel_return"
                 :value="encodeURI(paymentCancelReturnUrl) + '/' + plan.id">
          <input type="hidden" name="custom" :value="plan.custom">
          <div class="PayWall__modal__options__option__cover"
               :style="{ backgroundImage: `url(${scaleImage(plan.cover, [1, (1 / 2), (1 / 3), (1 / 5)])})` }"></div>
          <div class="PayWall__modal__options__option__title">
            <span class="title">{{plan.title}}</span>
            <span class="description">{{ plan.description }}</span>
            <span class="price">{{ plan.price }}</span>
          </div>
          <div class="PayWall__modal__options__option__button">
            <button type="submit" @click.prevent="isPlanValid(plan)">{{ $t('PAYWALL_BUY') }}
            </button>
          </div>
        </form>
      </div>
      <div class="PayWall__modal__options">
        <template v-for="plan in tickets" >
          <div class="PayWall__modal__options__option" v-if="isOfferVisible(plan.sku)" :key="plan.title">
            <div class="PayWall__modal__options__option__cover"
                 :style="{ backgroundImage: `url(${scaleImage(plan.cover, [1, (1 / 2), (1 / 3), (1 / 5)])})` }"></div>
            <div class="PayWall__modal__options__option__title">
              <span class="title">{{plan.title}}</span>
              <span class="description">{{ plan.description }}</span>
              <span class="price">{{ plan.price }}</span>
            </div>
            <div class="PayWall__modal__options__option__button">
              <button type="submit" @click.prevent="activateTicket(plan)">{{ $t('ACTIVATE_TICKET') }}
              </button>
            </div>
          </div>
        </template>
      </div>
    </template>
    <div class="PayWall__modal__help">
      <div class="PayWall__modal__help__title">
        {{ $t('SUPPORT_HEADER') }}
      </div>
      <div class="PayWall__modal__help__privacy" v-if="plans.policy">
        <a :href="plans.policy" target="_blank">{{ $t('tokvp_offer_plans_terms') }}</a>
      </div>
      <div class="PayWall__modal__help__text">
        <a :href="helpLink">{{ $t('HELP') }}</a>
      </div>
      <div class="PayWall__modal__help__text">
        <router-link to="/faq">{{ $t('faq') }}</router-link>
      </div>
      <div class="PayWall__modal__help__version">
        {{appName}} v{{ appVersion }}
      </div>
    </div>
  </section>
</template>
<script lang="js">
/* eslint max-len: ["error", { "code": 300 }] */

import {
  mapState,
  mapMutations,
  mapActions,
  mapGetters,
} from 'vuex';

import filter from 'lodash.filter';
import includes from 'lodash.includes';
import get from 'lodash.get';
import navBar from './NavBar.vue';
import bkg from './Bkg.vue';
import Redeem from './Redeem.vue';


export default {
  name: 'paywall',
  data() {
    return {
      polling: false,
      hash: false,
      transactionObj: false,
      dataTmp: false,
      thePlayer: null,
      hls: null,
      showWindow: false,
      address: '0xe381ec66ac701e2a4fa1c48eb97a17fc1d41e378',
      miniToken: false,
    };
  },
  beforeMount() {
    // 'Subscribe to Real Madrid Pass'
    this.setNavTitle(this.$t('SUBSCRIPTIONS_TITLE'));
  },
  mounted() {
    // window.ga('tok.send', 'screenview', { screenName: 'Subscription Paywall', appName: 'web' });
    // forEach(this.availablePlans.plans, (o) => {
    //   window.ga('tok.send', 'event', 'Subscription Paywall', 'Pay Item Shown', o.id);
    // });
    if (this.me && this.me.registered) {
      this.appReady(true);
    } else {
      this.$router.push('/');
    }
  },
  methods: {
    isOfferVisible(offer) {
      const restricted = get(this.redeem, 'offers', []);
      if (restricted.length > 0) {
        const canSee = includes(restricted, offer);
        return canSee;
      }
      return true;
    },
    activateTicket(plan) {
      let ro = {};
      if (this.redeem) {
        ro = {
          ...this.redeem,
          offers: [plan.sku],
          route: '/redeem',
        };
      } else {
        ro = {
          offers: [plan.sku],
          play: false,
          route: '/redeem',
        };
      }
      this.loadRedeem(ro);
    },
    isPlanValid(plan) {
      let planValid = true;
      if (!plan.button_url) planValid = false;
      if (!plan.custom) planValid = false;
      if (!plan.button_id) planValid = false;
      if (!planValid) {
        this.initModal({
          display: true,
          title: 'ERROR',
          text: 'Missing payment parameter',
          cta: this.$t('close'),
          callback: 'close',
          animation: 'tada',
        });
        return false;
      }
      this.payItemSelected(plan);
      this.$ls.set('pppd', plan);
      this.$refs[plan.button_id][0].submit();
      return false;
    },
    getToken(ls) {
      const status = ls.get('storageAccessData');
      if (status && status.token) {
        return status.token;
      }
      this.redirectToIP({
        registered: false,
      });
      return true;
    },

    pollResults(id) {
      this.api.get(`/cbether-subscription/${id}`, {
        headers: {
          'x-tok-token': this.getToken(this.$ls, this.$router),
          'Accept-Language': this.locale,
        },
      })
        .then((response) => {
          if (response.data.status === 'payment_pending') {
            setTimeout(() => {
              this.pollResults(response.data.id);
            }, 2000);
          } else {
            this.getPlans(true);
            this.getMe();
            this.polling = false;
          }
        });
    },
    payItemSelected(plan) {
      this.$log.info(plan.id);
      window.ga('tok.send', 'event', 'Subscription Paywall', 'Pay Item Selected', plan.id);
    },
    ...mapActions(['getPlans', 'getMe']),
    ...mapMutations([
      'setNavTitle',
      'appReady',
      'initModal',
      'loadRedeem',
    ]),
  },
  computed: {
    ...mapState(['displayRedeem', 'availablePlans', 'me', 'paymentReturnUrl', 'paymentCancelReturnUrl', 'helpLink', 'api', 'appVersion', 'appName', 'offersNeeded', 'locale', 'colors', 'plans', 'redeem']),
    ...mapGetters(['scaleImage', 'metamask']),
    hasSubscription() {
      if (this.availablePlans && this.availablePlans.active_plans) return this.availablePlans.active_plans.length;
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.$router.push('/');
    },
    hasUpgrades() {
      if (this.availablePlans && this.availablePlans.plans) return this.availablePlans.plans.length;
      return false;
    },
    tickets() {
      return filter(this.availablePlans.plans, (p) => {
        if (this.offersNeeded.length > 0) {
          return p.type === 'ticket' && includes(this.offersNeeded, p.offer);
        }
        return p.type === 'ticket';
      });
    },
    paypal() {
      return filter(this.availablePlans.plans, (p) => {
        if (this.offersNeeded.length > 0) {
          return p.type === 'paypal' && includes(this.offersNeeded, p.offer);
        }
        return p.type === 'paypal';
      });
    },
    eth() {
      return filter(this.availablePlans.plans, (p) => {
        if (this.offersNeeded.length > 0) {
          return p.type === 'cbether' && includes(this.offersNeeded, p.offer);
        }
        return p.type === 'cbether';
      });
    },
  },
  components: {
    navBar,
    bkg,
    Redeem,
  },
};
</script>
<style lang="scss" scoped>
.Paywall {
  &__no {
    display: flex;
    justify-content: center;
    color: white;
    align-items: center;
    font-size: 20px;
    padding: 30px 20px;
  }
}

.VueCarousel {
  margin-left: 0;
  margin-right: 0;
  width: 100%;
  margin-bottom: 20px;
}
</style>
